import SEO from "../components/seo";
import LayoutTwo from "../layouts/LayoutTwo";
import { useLocation } from "react-router-dom";
import { apiInstance } from "../helpers/axios";
import { useEffect, useState } from "react";
import LoadingScreen from "../components/loading/LoadingScreen";
import noDataImg from "../assets/images/no-data-icon.png";
import cogoToast from "cogo-toast";
import CategoryItem from "./category/CategoryItem";

const Search = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const query = searchParams.get("query");
  const [loadinData, setLoadingData] = useState(false);
  const [productData, setProductData] = useState([]);

  const getProducts = async () => {
    setLoadingData(true);

    const data = {
      Sku: query,
    };

    try {
      const response = await apiInstance.post("/Customer/getProductList", data);

      if (response.status === 200) {
        setProductData(response.data.Data ?? []);
      } else {
        cogoToast.error(response.data.Message || "Something went wrong!");
        throw new Error(response.data.Message || "Something went wrong!");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    getProducts();
    // eslint-disable-next-line
  }, [query]);

  return (
    <>
      <SEO titleTemplate="Contact" description="Contact page" />
      <LayoutTwo>
        <div className="container">
          <div className="search_top_bar">
            Search Results for: <span>{query}</span>
          </div>
          <div className="shop-bottom-area mt-40 mb-50">
            {loadinData && productData?.length === 0 ? (
              <LoadingScreen />
            ) : productData?.length === 0 ? (
              <div className="product_grid no_data">
                <div className="empty_icon_con">
                  <img src={noDataImg} alt="NO Data Icon" />
                  <p>No Data Found.</p>
                </div>
              </div>
            ) : (
              <div className="product_grid">
                {productData?.map((product, index) => (
                  <CategoryItem
                    product={product}
                    showSizes="false"
                    key={index}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </LayoutTwo>
    </>
  );
};

export default Search;
